import React from "react";
import { useInView } from 'react-intersection-observer';

import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";
import Description from "../../../components/Description";
import RadiusedButton from "../../../components/RadiusedButton";
import KvaliCodeWriter from "../../../components/KvaliCodeWriter/KvaliCodeWriter";

import reactIcon from "../../../resources/images/reactIcon.svg";
import androidIcon from "../../../resources/images/androidIcon.svg";
import iosIcon from "../../../resources/images/iosIcon.svg";

import {
  StyledContainer,
  StyledMainContainer,
  StyledLeftContainer,
  StyledRightContainer,
  StyledImageContainerCode,
  StyledCircleContainer,
  StyledCircle,
  StyledIconContainer,
  StyledButtonContainer,
  StyledResponsiveContainer,
} from "./ApiStructureStyle";

const ApiStructure = () => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <StyledContainer>
      <StyledMainContainer>
        <StyledLeftContainer>
          <ComponentTitle center value="apiStructureTitle" start />
          <Description
            value={"apiStructureDescription"}
            textColor="#797A80"
            textMaxWidth="393px"
            start
          />
          <StyledResponsiveContainer>
            <img src={reactIcon} alt="" />
            <img src={androidIcon} alt="" />
            <img src={iosIcon} alt="" />
          </StyledResponsiveContainer>
          <StyledButtonContainer>
            <RadiusedButton 
              value="seeDocs"
              hrefValue={'https://github.com/kvalifika/'}
            />
          </StyledButtonContainer>
          <StyledIconContainer>
            <img src={reactIcon} alt="" />
            <img src={androidIcon} alt="" />
            <img src={iosIcon} alt="" />
          </StyledIconContainer>
        </StyledLeftContainer>
        <StyledRightContainer ref={ref}>
          <StyledImageContainerCode>
            <StyledCircleContainer>
              <StyledCircle bgColor={"#FFF37E"} />
              <StyledCircle bgColor={"#D284FC"} />
              <StyledCircle bgColor={"#0068FF"} />
            </StyledCircleContainer>
            {inView && <KvaliCodeWriter />}
          </StyledImageContainerCode>
        </StyledRightContainer>
      </StyledMainContainer>
    </StyledContainer>
  );
};

export default ApiStructure;
